import React, { useState } from 'react';
import VideoCarousel from '../Shared/VideoCarousel';
import PhotoGrid from '../Shared/PhotoGrid';
import './Portfolio.css';

export default function Portfolio() {
	const [activeTab, setActiveTab] = useState('my-portfolio');

	// Short Film videos data
	const shortFilmVideos = [
		{
			type: 'video',
			source: 'https://kng-portfolio-videos.s3.amazonaws.com/RECURVE.mp4',
			title: 'Recurve (2024)',
			details: '2nd Assistant Camera',
			thumbnail: 'images/thumbnails/Recurve.jpg',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/Lust-for-a-Shesquatch.mp4',
			title: 'Lust for a Shesquatch (2024)',
			details: '1st Assistant Camera',
			thumbnail: 'images/thumbnails/LFAS.jpg',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/are-you-bored-yet.mp4',
			title: 'Are You Bored Yet? (2024)',
			details: '1st Assistant Camera',
			thumbnail: 'images/thumbnails/AYBY.jpg',
		},
		{
			type: 'video',
			source: 'https://kng-portfolio-videos.s3.amazonaws.com/La-Fem.mp4',
			title: 'La Fem (2024)',
			details: '1st Assistant Camera and Gaffer',
			thumbnail: 'images/thumbnails/LF.png',
		},
		{
			type: 'video',
			source: 'https://kng-portfolio-videos.s3.amazonaws.com/Spittin-Bars.mp4',
			title: 'Spittin Bars (2024)',
			details: 'Cinematographer',
			thumbnail: 'images/thumbnails/SB.jpg',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/Tastebuds_FINAL.mp4',
			title: 'Tastebuds (2024)',
			details: 'Assistant Grip',
			thumbnail: 'images/thumbnails/Tastebuds.png',
		},
		{
			type: 'youtube',
			youtubeId: '7muuRD4gkWw',
			title: 'Photophobia (2025)',
			details: '1st Assistant Camera',
			thumbnail: 'images/thumbnails/Photophobia-Thumbnail-Option-1.png',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/Under%20the%20Surface%202023.mp4',
			title: 'Under The Surface (2023)',
			details: 'Actress',
			thumbnail: 'images/thumbnails/Under-The-Surface-Thumbnail.png',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/Neighbor%202023.mp4',
			title: 'Neighbor (2023)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/Neighbor-Thumbnail.png',
		},
		{
			type: 'video',
			source:
				'https://kng-portfolio-videos.s3.amazonaws.com/My%20other%20Half%202023.mp4',
			title: 'My Other Half (2023)',
			details: 'Cinematographer and Editor',
			thumbnail: 'images/thumbnails/My-Other-Half-Thumbnail.png',
		},
		{
			type: 'video',
			source: 'https://kng-portfolio-videos.s3.amazonaws.com/Jenga%202023.mov',
			title: 'Jenga (2023)',
			details: 'Cinematographer, Writer, and Editor',
			thumbnail: 'images/thumbnails/Jenga-Thumbnail.png',
		},
	];

	// Music Video data
	const musicVideos = [
		{
			type: 'youtube',
			youtubeId: 'K5sgTJoQHXA',
			title: 'Out My Mind by LECARDIEAY (2026)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: '4FD4zc5hhYc',
			title: 'FRIENDSTOENEMIES by TreTheDon (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: 'Uo1Pdh9-Psc',
			title: 'Tell Me by LECARDIEAY (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: '9KJmBhQ9okc',
			title: 'I Got Swag by Jayskiiii (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: 'xc2m1TgK888',
			title: 'Sailor Moon by GRI0T (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
	];

	// Social Media videos (placeholder)
	const socialMediaVideos = [
		{
			type: 'youtube',
			youtubeId: 'VLpV-_abOA0',
			title: 'Salient Content (2025)',
			details: 'Social Media',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
	];

	// Portfolio photos
	const portfolioPhotos = [
		'images/portfolio/Between-the-Heads.jpg',
		'images/portfolio/Downtown-Austin.jpg',
		'images/portfolio/The-Boat.jpg',
		'images/portfolio/The-House-at-the-End.jpg',
		'images/portfolio/Town-on-the-Water.jpg'
		// TODO: Add Salient Goalie photos here
	];

	// Life on Set photos (removed Blanton Museum photo)
	const lifeOnSetPhotos = [
		'images/DSCF0001.JPEG',
		'images/IMG_3182.JPEG',
		'images/107_1318.JPEG',
		'images/DSCF0035.JPEG',
		'images/DSCF0279.JPEG',
		'images/IMG_3006.JPEG',
		'images/IMG_3038.JPEG',
		'images/IMG_3081.JPEG',
		'images/IMG_3007.JPEG',
		'images/IMG_3176.JPEG',
		'images/DSCF0038.JPEG',
	];
	const renderMyPortfolio = () => (
		<div className='tab-content'>
			<VideoCarousel
				title='Short Film'
				videos={shortFilmVideos}
				sectionId='short-film'
			/>
			<VideoCarousel
				title='Music Video'
				videos={musicVideos}
				sectionId='music-video'
			/>
			<VideoCarousel
				title='Social Media'
				videos={socialMediaVideos}
				sectionId='social-media'
			/>
			<PhotoGrid title='Photos' photos={portfolioPhotos} />
		</div>
	);

	const renderLifeOnSet = () => (
		<div className='tab-content'>
			<PhotoGrid photos={lifeOnSetPhotos} />
		</div>
	);

	return (
		<main className='portfolio-page'>
			<div className='tab-navigation'>
				<button
					className={`tab-button ${
						activeTab === 'my-portfolio' ? 'active' : ''
					}`}
					onClick={() => setActiveTab('my-portfolio')}>
					My Portfolio
				</button>
				<button
					className={`tab-button ${
						activeTab === 'life-on-set' ? 'active' : ''
					}`}
					onClick={() => setActiveTab('life-on-set')}>
					Life on Set
				</button>
			</div>

			{activeTab === 'my-portfolio' ? renderMyPortfolio() : renderLifeOnSet()}
		</main>
	);
}
